// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"dbe56212","422":"8f682098","777":"a7e66226"}[chunkId] + ".chunk.js";
};